import { type WithOnChange, type WithValue } from "@common/declarations";
import * as React from "react";

type SharedProps<T> = WithValue<T> & WithOnChange<T>;

export type WithValidateHOCProps<T> = SharedProps<T>;

export type WithValidateCmpProps<T> = SharedProps<T> & {
  isValid: boolean;
};

export interface State {
  isValid: boolean;
}
const withValidateHOC =
  <TValue, OriginalProps extends {}>(
    Cmp: React.ComponentType<OriginalProps & WithValidateCmpProps<TValue>>,
    validate: (value: TValue, props: OriginalProps) => boolean
  ) =>
  (props: OriginalProps & WithValidateHOCProps<TValue>) => {
    const [isValid, setIsValid] = React.useState(true);

    const onChange = (value: TValue) => {
      const isValid = validate(value, props);
      if (isValid !== isValid) {
        setIsValid(isValid);
      }
      props.onChange(value);
    };

    return <Cmp {...props} onChange={onChange} isValid={isValid} />;
  };

export default withValidateHOC;
